import { useClickOutside, useDisclosure } from '@mantine/hooks';
import { ActionIcon, Transition } from '@mantine/core';

import SearchBar from './NavBarSearchBar';

import SearchIcon from '@/assets/icons/content/search.svg';

import classes from './NavBarSearchBar.module.css';

const Mobile = () => {
  const [opened, { open, close }] = useDisclosure();
  const clickOutsideRef = useClickOutside(close);

  return (
    <div>
      <ActionIcon variant="subtle" onClick={open} aria-label="Open Search">
        <SearchIcon />
      </ActionIcon>

      <Transition mounted={opened} transition="slide-down" duration={400} timingFunction="ease">
        {(styles) => (
          <div style={styles} className={classes.mobileWrapper} ref={clickOutsideRef}>
            <SearchBar onSearch={close} dense />
          </div>
        )}
      </Transition>
    </div>
  );
};

export default Mobile;
